angular.module("app").controller("MediasListPageController", [
    '$scope',
    'mediaService',
    'errorHandler',
    'logger',
    'preloadedUsersList',
    'preloadedImages',
    '$timeout',
    'pageStatuses',
    'pagination',
    function ($scope, mediaService, errorHandler, logger, preloadedUsersList, preloadedImages, $timeout, pageStatuses, pagination) {

        var pendingListRequest;

        $scope.pageStatuses = pageStatuses;
        $scope.filterOptions = {
            status: $scope.pageStatuses[0],
            user: ""
        };


        $scope.pagination = pagination.init(function () {
                !!pendingListRequest && $timeout.cancel(pendingListRequest);
                pendingListRequest = $timeout(function () {
                    $scope.updateList(getFiltersValues())
                }, 300);
            }, preloadedUsersList.total_count);

        $scope.images = angular.copy(preloadedImages.items || []);

        $scope.users = angular.copy(preloadedUsersList.users);

        $scope.users.push({id: "", name: "all"});

        $scope.updateList = function (requestOptions) {
            !requestOptions.userId && (delete requestOptions.userId);
            requestOptions.status = $scope.filterOptions.status;
            requestOptions.limit = $scope.pagination.limit;
            mediaService.getImages(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.images = angular.copy(response.items)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.deleteImage = function (id) {
            mediaService.deleteImage({id: id}).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("Image has been successfully deleted");
                        $scope.updateList(getFiltersValues())
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function getFiltersValues () {
            return {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
                userId:  $scope.filterOptions.user
            }
        }

    }
]);